<template>
  <BaseTableView :head="tableHead">
    <WorkClientPersonTableItem v-for="item in items" :key="item.id" :item="item" />
  </BaseTableView>
</template>

<script>
import WorkClientPersonTableItem from 'components/workClient/person/WorkClientPersonTableItem'
export default {
  name: 'WorkClientPersonTable',
  props: ['items'],
  components: { WorkClientPersonTableItem },
  data() {
    return {}
  },
  computed: {
    tableHead() {
      return [
        {
          text: this.localStorage.translations.pages['setting-client']['persons']['imya'],
          sort: {
            name: 'first_name',
            value:
              this.$route.query.sort_param && this.$route.query.sort_param === 'first_name'
                ? this.$route.query.sort_value && this.$route.query.sort_value === 'desc'
                  ? 'asc'
                  : 'desc'
                : 'asc',
          },
        },
        {
          text: this.localStorage.translations.pages['setting-client']['persons']['familiya'],
          sort: {
            name: 'last_name',
            value:
              this.$route.query.sort_param && this.$route.query.sort_param === 'last_name'
                ? this.$route.query.sort_value && this.$route.query.sort_value === 'desc'
                  ? 'asc'
                  : 'desc'
                : 'asc',
          },
        },
        {
          text: this.localStorage.translations.pages['setting-client']['persons']['dolzhnost'],
          sort: {
            name: 'position',
            value:
              this.$route.query.sort_param && this.$route.query.sort_param === 'position'
                ? this.$route.query.sort_value && this.$route.query.sort_value === 'desc'
                  ? 'asc'
                  : 'desc'
                : 'asc',
          },
        },
        {
          text: this.localStorage.translations.pages['setting-client']['persons'][
            'elektronnaya-pochta'
          ],
          sort: {
            name: 'email',
            value:
              this.$route.query.sort_param && this.$route.query.sort_param === 'email'
                ? this.$route.query.sort_value && this.$route.query.sort_value === 'desc'
                  ? 'asc'
                  : 'desc'
                : 'asc',
          },
        },
        {
          text: this.localStorage.translations.pages['setting-client']['persons']['telefon'],
        },
        {active: true},
      ]
    },
  },
  methods: {},
  watch: {},
}
</script>
